import axiosInstance from '../utils/httpInterceptors';
import reportsAxiosInstance from '../utils/reportsInterceptors';
export const globalGetService = (url, params, retry=2) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'GET',
        url: url,
        params: params && Object.keys(params).length ? {...params,timestamp: new Date().getTime()} : {timestamp: new Date().getTime()}
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
          if(retry>0){
            globalGetService(url,params,retry-1)
          }
          resolve(error);
        // reject(error)
      })
    }
  )
}
export const globalLeaseGetService = (url, params, retry = 2) => {
  return new Promise(
    function (resolve, reject) {
      axiosInstance({
        method: 'GET',
        url: url,
        params: params && Object.keys(params).length ? { ...params } : {}
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          if (retry > 0) {
            globalLeaseGetService(url, params, retry - 1)
          }
          resolve(error);
          // reject(error)
        })
    }
  )
}
export const globalPostService = (url, data, retry=2) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'POST',
        url: url,
        data: data
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
            if(retry>0){
            globalPostService(url,data,retry-1)
          }
          resolve(error);
        // reject(error)
      })
    }
  )
}
export const globalPutService = (url, data) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'PUT',
        url: url,
        data: data
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error)
      })
    }
  )
}
export const globalDeleteService = (url, data) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'DELETE',
        url: url,
        data: data
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error)
      })
    }
  )
}

export const globalExportService = (url, queryParams={}, type) => {
  if(type === 'marketing'){
    return new Promise(function(resolve, reject){
      reportsAxiosInstance({
        method: 'GET',
        url: url,
        responseType: 'blob',
        params: queryParams
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error)
      })
    })
  } else {
  return new Promise(function(resolve, reject){
    axiosInstance({
      method: 'GET',
      url: url,
      responseType: 'blob',
      params: queryParams
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      reject(error)
    })
  })
}
}

export const globalFileUploadService = (url, data, config) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance.post(url, data, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(error => {
        reject(error)
      })
    }
  )
}

